import React from 'react';
import { isFunction } from 'utils/utils';

function Accordion({
  title,
  id,
  children,
  open,
}: {
  title: React.ReactNode | { ({ isOpen }: { isOpen: boolean }): React.ReactNode };
  id: string;
  open?: boolean;
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = React.useState(open || false);

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        className={`flex items-center w-full py-8 font-medium text-[15px] text-river-blue text-left 
          ${!isOpen ? 'border-b-[1px] border-[#E0E4E7]' : ''}`}
        aria-expanded="true"
        aria-controls={id}
      >
        {isFunction(title) ? title({ isOpen }) : title}
      </button>

      <div id={id} className={isOpen ? 'block -mt-4' : 'hidden'} aria-labelledby={id}>
        <div className="px-0 pt-0 pb-8 border-b-[1px] border-[#E0E4E7]">{children}</div>
      </div>
    </>
  );
}

export default Accordion;
